// extracted by mini-css-extract-plugin
export default {"section":"index_section__A782z"};